/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ScheduleSetting = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        company_id: {
    type: 'number',
    isRequired: true,
},
        settings: {
    type: 'SettingsPayload',
    isRequired: true,
},
    },
};